import React, { useContext, useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";


const Header = ({ handleLogout }) => {
  const location = useLocation();
  const { payload, token, isAdmin } = useContext(AuthContext);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);


  const routeTitles = {
    "/": "Collections",
    "/contents": "Raw Contents",
    "/translation": "Translation",
    "/segregate": "Segregate - Split & Merge",
    "/locate": "Locate",
    "/trace": "Trace Your Data",
    "/locate-merge": "Locate & Merge",
    "/search": "Search - Contents",
    "/datatransfer": "Transfer To Source",
    "/translationdataverification": "Prepare For Translation",
    "/downloaddata": "Download For Translation",
    "/verification": "Verify Translation",
    "/domain": "Domain Page",
  };


  const title =
    routeTitles[location.pathname] || "Dashboard";


  // User Info

  const user = token
    ? {
      id:
        payload?.sub ||
        payload?.user_id ||
        payload?.id ||
        null,

      name:
        payload?.name ||
        payload?.user?.name ||
        "User",

      email:
        payload?.email ||
        payload?.user?.email ||
        "",

      profileImage:
        payload?.profile_picture ||
        payload?.avatar ||
        payload?.user?.profileImage ||
        "",
    }
    : null;



  // Close dropdown outside click

  useEffect(() => {

    const handleClickOutside = (event) => {

      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target)
      ) {
        setDropdownOpen(false);
      }

    };


    document.addEventListener(
      "mousedown",
      handleClickOutside
    );


    return () =>
      document.removeEventListener(
        "mousedown",
        handleClickOutside
      );

  }, []);



  const getInitials = (name) => {

    if (!name || typeof name !== "string")
      return "U";


    const parts = name.trim().split(/\s+/);


    if (parts.length > 1) {
      return (
        parts[0][0] +
        parts[parts.length - 1][0]
      ).toUpperCase();
    }


    return parts[0][0].toUpperCase();

  };



  return (
    <div className="position-relative bg-primary px-4 py-2 rounded-3 shadow mb-3 d-flex align-items-center justify-content-center">
      {/* Center Title */}
      <Link
        to={location.pathname}
        className="text-white text-decoration-none fw-bold fs-4"
      >
        {title}
      </Link>


      {/* Right Profile Fixed */}
      {user && (
        <div
          className="position-absolute end-0 me-3"
          ref={dropdownRef}
        >

          <button
            className="btn btn-light rounded-pill d-flex align-items-center gap-2 px-3 shadow-sm"
            onClick={() => setDropdownOpen(!dropdownOpen)}
          >

            {user.profileImage ? (
              <img
                src={user.profileImage}
                alt="Profile"
                className="rounded-circle border border-2 border-primary shadow"
                style={{
                  width: "40px",
                  height: "40px",
                  objectFit: "cover"
                }}
              />
            ) : (
              <div
                className="
            rounded-circle
            bg-primary
            text-white
            fw-bold
            d-flex
            align-items-center
            justify-content-center
            border
            border-2
            border-white
            shadow
          "
                style={{
                  width: "40px",
                  height: "40px"
                }}
              >
                {getInitials(user.name)}
              </div>
            )}

            <span className="fw-semibold">
              {user.name}
            </span>

          </button>


          {/* Dropdown */}
          {dropdownOpen && (
            <div
              className="position-absolute end-0 mt-2 bg-white rounded-3 shadow-lg border p-2"
              style={{
                width: "260px",
                zIndex: 1050
              }}
            >

              <div className="px-3 py-2 border-bottom text-start">
                <div className="fw-bold text-dark">
                 <strong>Name:</strong> {user.name}
                </div>
                <small className="text-muted">
                <strong>Email:</strong> {user.email}
                </small>
              </div>

              <button
                className="text-start dropdown-item text-danger rounded px-3 py-2"
                onClick={handleLogout}
              >
                Logout
              </button>

            </div>
          )}

        </div>
      )}

    </div>

  );

};


export default Header;